import api from '@/lib/api';
import type { ApiResponse } from '@/types';

export interface ClientConfig {
  telephony_socket_token: string | null;
  vapid_public_key: string | null;
  // Languages this clinic writes to patients in (dial-code map values +
  // fallback). Drives the per-language recall reminder body fields.
  patient_languages: string[];
}

let cached: Promise<ClientConfig> | null = null;

// Runtime replacement for per-clinic values historically baked into the bundle
// at build time. Falls back to the baked NEXT_PUBLIC_* values so per-clinic
// locally-built images behave exactly as before; on the fleet-generic image
// (nothing baked) the backend is the only source.
export function getClientConfig(): Promise<ClientConfig> {
  if (!cached) {
    cached = api
      .get<ApiResponse<ClientConfig>>('/client-config')
      .then((response) => response.data.data)
      .catch(() => null)
      .then((config) => {
        const resolved: ClientConfig = {
          telephony_socket_token:
            config?.telephony_socket_token ||
            process.env.NEXT_PUBLIC_TELEPHONY_SERVICE_KEY ||
            null,
          vapid_public_key:
            config?.vapid_public_key ||
            process.env.NEXT_PUBLIC_VAPID_PUBLIC_KEY ||
            null,
          patient_languages: config?.patient_languages?.length
            ? config.patient_languages
            : ['en'],
        };
        // A transient fetch failure with no baked fallback must not pin nulls
        // for the whole session — let the next caller retry.
        if (!config && !resolved.telephony_socket_token && !resolved.vapid_public_key) {
          cached = null;
        }
        return resolved;
      });
  }
  return cached;
}
